// react library imports
import { motion } from "framer-motion";

// main component imports
import { TeamCard } from "Component";

// style imports and import from utils
import './Team.css';
import { useAnimationHook, teamCardAnimation } from "Utils/animation";

const Team = ({data}) => {
  const {ref, mainControls}=useAnimationHook(0.2)
  return (
    <motion.div  ref={ref} className='about_team_container'
    initial="hidden" animate={mainControls} transition={{staggerChildren:0.1}}>
        <motion.h2 className="mues_black mues_font_weight_700
        mues_text_align_center mues_margin_bottom_16 padding_container"
        variants={teamCardAnimation}>{data.title}</motion.h2>
        <div className='about_team_review_container padding_container'>
          {data.review?.map(item=>(
            <TeamCard name={item.name} key={item.id} profile={item.profile}
            designation={item.designation} description={item.description}
            src={item.image}/>
          ))}
        </div>
    </motion.div>
  )
}

export default Team